var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.36107 1.71788C2.66819 1.73661 2.08766 1.98006 1.6195 2.44822C1.15133 2.91639 0.907887 3.49691 0.88916 4.18979V11.8302C0.907887 12.5231 1.15133 13.1037 1.6195 13.5718C2.08766 14.04 2.66819 14.2834 3.36107 14.3022H12.7993C13.4922 14.2834 14.0727 14.04 14.5408 13.5718C15.009 13.1037 15.2525 12.5231 15.2712 11.8302V6.88642C15.2525 6.19354 15.009 5.61302 14.5408 5.14485C14.0727 4.67669 13.4922 4.43324 12.7993 4.41451H4.25995C3.84796 4.45197 3.62324 4.67669 3.58579 5.08867C3.62324 5.50066 3.84796 5.72537 4.25995 5.76283H12.7993C13.1176 5.76283 13.3798 5.87519 13.5858 6.09991C13.8105 6.3059 13.9229 6.56807 13.9229 6.88642V11.8302C13.9229 12.1486 13.8105 12.4108 13.5858 12.6168C13.3798 12.8415 13.1176 12.9538 12.7993 12.9538H3.36107C3.04272 12.9538 2.78055 12.8415 2.57455 12.6168C2.34983 12.4108 2.23747 12.1486 2.23747 11.8302V4.18979C2.23747 3.87144 2.34983 3.60927 2.57455 3.40328C2.78055 3.17856 3.04272 3.0662 3.36107 3.0662H13.6981C14.1101 3.02875 14.3349 2.80403 14.3723 2.39204C14.3349 1.98006 14.1101 1.75534 13.6981 1.71788H3.36107ZM11.6757 10.2572C11.9378 10.2572 12.1532 10.1729 12.3217 10.0044C12.4903 9.83586 12.5746 9.62051 12.5746 9.35833C12.5746 9.09616 12.4903 8.88081 12.3217 8.71227C12.1532 8.54373 11.9378 8.45946 11.6757 8.45946C11.4135 8.45946 11.1981 8.54373 11.0296 8.71227C10.8611 8.88081 10.7768 9.09616 10.7768 9.35833C10.7768 9.62051 10.8611 9.83586 11.0296 10.0044C11.1981 10.1729 11.4135 10.2572 11.6757 10.2572Z",
    fill: "#003768"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5,
    height: 15,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.830078 15.51)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.7a7b1c1ad262c1bbb2e9dbb892ed1026.svg";
export { ForwardRef as ReactComponent };